import React, { useState } from "react"
import {ReactComponent as Wallet} from "../../assets/icons/TalkLawer/wallet.svg"
import useAlertStack from 'ui-components/lib/hooks/useAlertStack'

export const MeetTopic = (props) => {
    let changeView = props.changeView
    let meetSubject = props.meetSubject
    let walletData = props.walletData
    let subservice = props.subservice
    const [meetSubjectM,setMeetSubjectM] = useState(props.subjectName);
    const { showMessage } = useAlertStack()

    const handleMeetSubject = (e) => {
      e.preventDefault()
      let error = false

      if (meetSubjectM === "" || meetSubjectM === null) {
        showMessage({
          title: 'Erro ao prosseguir',
          message: 'Todos os campos devem ser preenchidos',
          color: 'alert',
          position: 'bottom-left',
          time: 4000,
        })
        error = true
      }

      if (error === false){
        meetSubject(meetSubjectM)
        changeView(1)
      }
    }

    return (
        <>
          <div className="d-flex justify-content-start mt-3">
            {walletData?.wallet?.balance < subservice?.clientPrice?.amount && !props.isJp ? (
              <div className="alert alert-danger w-100" role="alert">
                <p onClick={()=>window.location.href='/dashboard/carteira'}>Você não possui bnz's suficientes para solicitar este serviço! <strong><u>Comprar BNZ's</u></strong></p>
              </div>
            ):(
              <div>
                <h4 className="mb-3">Você selecionou a opção de agendar uma reunião com um dos nossos advogados. Por favor, nos informe o assunto a ser tratado:</h4>
                <div style={{marginBottom: '24px'}}>
                    <input 
                        type='text' 
                        value={meetSubjectM} 
                        disabled={props.subjectName !== ""} 
                        onChange={event => setMeetSubjectM(event.target.value)} 
                        name="topic" 
                        placeholder="Ex: Contrato de trabalho, Divórcio, Herança..."
                        style={{marginBottom: '8px'}}
                    />
                    <small style={{color: 'var(--text-secondary)', fontSize: '14px'}}>Descreva brevemente o assunto que deseja tratar na reunião</small>
                </div>
                <div className="btn-position">
                    <button className="btn btn-blue" onClick={(e) => handleMeetSubject(e)}>Avançar</button>
                </div>
              </div>
            )}
          </div>
        </>
    )
}

export const MeetDate = ({changeView,meeetDate,googleAgenda}) => {
    const [inputDisable, setInputDisable] = useState(true)
    const [meetDate,setMeetDate] = useState("");
    const { showMessage } = useAlertStack()

    const handleMeetDate = (e) => {
        e.preventDefault()
        let error = false

        if (meetDate === "" || meetDate === null) {
          showMessage({
            title: 'Erro ao prosseguir',
            message: 'Todos os campos devem ser preenchidos',
            color: 'alert',
            position: 'bottom-left',
            time: 4000,
          })
          error = true
        }

        if (error === false){
          meeetDate(meetDate)
          changeView(2)
        }
      }

    return (
        <>
            <h4 className="mb-3">Digite a data desejável para agendar a reunião (no mínimo 3 opções).</h4>
            <div style={{marginBottom: '32px'}}>
                <textarea 
                    required 
                    name="date" 
                    onChange={event => setMeetDate(event.target.value)} 
                    placeholder="Ex: 15/01/2024 às 14h, 16/01/2024 às 10h, 17/01/2024 às 15h" 
                    rows="4" 
                    className="form-control"
                    value={meetDate}
                />
                <small style={{color: 'var(--text-secondary)', fontSize: '14px', marginTop: '8px', display: 'block'}}>Informe pelo menos 3 opções de data e horário para facilitar o agendamento</small>
            </div>
            <div className="d-flex align-items-center" style={{marginBottom: '16px'}}>
                <input 
                    className="form-check-input" 
                    required 
                    style={{marginRight: '12px', marginTop: '0'}} 
                    type="checkbox" 
                    value="" 
                    onClick={() => setInputDisable(!inputDisable)}
                    id="share-agenda"
                />
                <label htmlFor="share-agenda" style={{margin: 0, cursor: 'pointer', fontWeight: 500}}>Compartilhar minha agenda</label>
            </div>
            <p style={{color: 'var(--text-secondary)', fontSize: '14px', marginBottom: '12px'}}>Compartilhe o link do seu Google Agenda para facilitar o agendamento</p>
            <input 
                type='text' 
                name="google-meet" 
                required 
                onChange={event => googleAgenda(event.target.value)} 
                placeholder="https://calendar.google.com/calendar/..." 
                disabled={inputDisable}
                style={{marginBottom: '32px'}}
            />
            <div className="btn-position">
                <button onClick={() => changeView(0)} className="btn btn-out-blue" style={{marginRight: '10px'}}>Voltar</button>
                <button onClick={(e) => handleMeetDate(e)} className="btn btn-blue">Avançar</button>
            </div>
        </>
    )
}


export const MeetTime = ({changeView, meetHour}) => {

    const { showMessage } = useAlertStack()

    const options = [
        { value: '8h30', label: '8h30' },
        { value: '9h00', label: '9h00' },
        { value: '9h30', label: '9h30' },
        { value: '10h00', label: '10h00' },
        { value: '10h30', label: '10h30' },
        { value: '11h00', label: '11h00' },
        { value: '11h30', label: '11h30' },
        { value: '12h00', label: '12h00' },
        { value: '12h30', label: '12h30' },
        { value: '13h00', label: '13h00' },
        { value: '13h30', label: '13h30' },
        { value: '14h00', label: '13h30' },
        { value: '14h30', label: '13h30' },
        { value: '15h00', label: '13h30' },
        { value: '15h30', label: '15h30' },
        { value: '16h00', label: '16h00' },
        { value: '16h30', label: '16h30' },
        { value: '17h00', label: '17h00' },
        { value: '17h30', label: '17h30' },
    ];

    const [suggestion1,setSuggestion1] = useState("");
    const [suggestion2,setSuggestion2] = useState("");
    const [suggestion3,setSuggestion3] = useState("");

    const handleSendAllSuggestionHours = (e) =>{
      e.preventDefault()
      let suggestionHours = [suggestion1,suggestion2,suggestion3];
      let suggestionHour = suggestionHours.join(",");
      let error = false

      if(suggestion1 === "" || suggestion2 === "" || suggestion3 === ""){
        showMessage({
          title: 'Erro ao prosseguir',
          message: 'Todos os campos devem ser preenchidos',
          color: 'alert',
          position: 'bottom-left',
          time: 4000,
        })
        error = true
      }


      if(suggestion1 === suggestion2 ||
        suggestion1 === suggestion3 ||
        suggestion2 === suggestion1 ||
        suggestion2 === suggestion3 ||
        suggestion3 === suggestion1 ||
        suggestion3 === suggestion2 ){

        showMessage({
          title: 'Erro ao prosseguir',
          message: 'Os Horários devem ser diferentes',
          color: 'danger',
          position: 'bottom-left',
          time: 4000,
        })
        error = true
      }

      if(error === false){
        meetHour(suggestionHour)
        changeView(3)
      }
    }


    return (
        <>
            <h4 className="mb-4">Escolha até três horários de preferência para marcar a reunião.</h4>
            <h6>Primeira opção</h6>
            <select className="basic-multi-select select form-control" onChange={(event)=>setSuggestion1(event.target.value)}>
              <option selected disabled>Selecione um horário</option>
              {options.map((option,counter)=>{
                return (
                  <option value={option.value}>
                    {option.label}
                  </option>
                )
              })};
            </select>
          <h6>Segunda opção</h6>
          <select className="basic-multi-select select form-control" onChange={(event)=>setSuggestion2(event.target.value)}>
            <option selected disabled>Selecione um horário</option>
            {options.map((option,counter)=>{
              return (
                <option value={option.value}>
                  {option.label}
                </option>
              )
            })};
          </select>
          <h6>Terceira opção</h6>
          <select className="basic-multi-select select form-control" onChange={(event)=>setSuggestion3(event.target.value)}>
            <option selected disabled>Selecione um horário</option>
            {options.map((option,counter)=>{
              return (
                <option key={counter} value={option.value}>
                  {option.label}
                </option>
              )
            })};
          </select>
            <div className="btn-position">
                <button onClick={() => changeView(1)} className="btn btn-out-blue" style={{marginRight: '10px'}}>voltar</button>
                <button onClick={(e) => handleSendAllSuggestionHours(e)} className="btn btn-blue">Avançar</button>
            </div>
        </>
    )
}

export const Payment = ({changeView, subservice,createDemand, isJp}) => {

    return (
        <>
            <div className="d-flex justify-content-between mb-4" style={{flexWrap: 'wrap', gap: '24px'}}>
               <div style={{flex: 1, minWidth: '250px'}}>
                    <h4>Fale com Advogado Bonuz por 30 min.</h4>
                    <p style={{color: 'var(--text-secondary)', marginTop: '8px'}}>Um dos nossos especialistas irá entrar em contato para confirmar o agendamento</p>
                </div>
                <div className="total" style={{flexShrink: 0}}>
                  {isJp ?
                    (
                      <>
                        <h6><span><Wallet fill="#F14F5C"/></span> Total da solicitação</h6>
                        <span style={{color: '#F14F5C', fontSize: "28px", fontWeight: '700'}}>1 Crédito</span>
                      </>
                    )
                    :
                    (
                      <>
                        <h6><span><Wallet fill="#F14F5C"/></span> Total da compra</h6>
                        <span style={{color: '#F14F5C', fontSize: "28px", fontWeight: '700'}}>{subservice?.clientPrice?.amount} BNZ's</span>
                      </>
                    )
                  }
                </div>
            </div>
            <div className="btn-position">
                <button onClick={() => changeView(1)} className="btn btn-out-blue" style={{marginRight: '10px'}}>Voltar</button>
                <button onClick={() => createDemand()} className="btn btn-blue">Confirmar e Finalizar</button>
            </div>
        </>
    )
}

export const Confirm = ({changeView}) => {
    return (
        <>
            <div style={{textAlign: 'center', padding: '40px 20px'}}>
                <div style={{width: '80px', height: '80px', borderRadius: '50%', background: 'linear-gradient(135deg, var(--success-color) 0%, #3DBD7D 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', boxShadow: '0 4px 16px rgba(68, 228, 122, 0.3)'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </div>
                <h4 style={{marginBottom: '16px', color: 'var(--text-color)'}}>Solicitação realizada com sucesso!</h4>
                <p style={{color: 'var(--text-secondary)', fontSize: '16px', lineHeight: '160%', marginBottom: '8px'}}>Aguarde um dos nossos especialistas entrar em contato para marcar um horário para reunião.</p>
                <small style={{color: 'var(--text-secondary)', fontSize: '14px', display: 'block', marginBottom: '32px'}}>Enviaremos um e-mail com o link da reunião assim que o agendamento for confirmado.</small>
            </div>
            <div className="btn-position">
                <button onClick={() => window.location.href = '/dashboard/serviços'} className="btn btn-blue" style={{width: '100%', maxWidth: '300px', margin: '0 auto'}}>Ver meus serviços</button>
            </div>
        </>
    )
}
